/* eslint-disable jsx-a11y/label-has-for */
import React, { PureComponent } from 'react';
import CheckIcon from 'mdi-react/CheckIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class CheckBoxField extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]).isRequired,
    label: PropTypes.node, // Cambiado de string a node
    defaultChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.shape({}),
    labelStyle: PropTypes.shape({}),
    color: PropTypes.string,
  };

  static defaultProps = {
    label: '',
    defaultChecked: false,
    disabled: false,
    className: '',
    style: {},
    labelStyle: {},
    color: '',
  };

  componentDidMount() {
    // const { onChange, defaultChecked } = this.props;
    // onChange(defaultChecked);
  }

  render() {
    const {
      disabled,
      className,
      name,
      value,
      onChange,
      label,
      color,
      defaultChecked,
      style,
      labelStyle,
    } = this.props;

    const CheckboxClass = classNames({
      'checkbox-btn': true,
      disabled,
    });

    const checked = value !== '' ? value : defaultChecked;
    const checkedClass = checked ? 'checkbox-btn--checked' : '';
    const labelClass = `${CheckboxClass} ${checkedClass} ${className ? `checkbox-btn--${className}` : ''}`;

    return (
      <label
        style={labelStyle}
        className={labelClass}
        htmlFor={name}
      >
        <input
          style={style}
          className="checkbox-btn__checkbox"
          type="checkbox"
          id={name}
          name={name}
          onChange={onChange}
          checked={checked}
          disabled={disabled}
        />
        <span
          className="checkbox-btn__checkbox-custom"
          style={color ? { background: color, borderColor: color } : {}}
        >
          <CheckIcon />
        </span>
        {className === 'button'
          ? (
            <span className="checkbox-btn__label-svg">
              <CheckIcon className="checkbox-btn__label-check" />
              <CloseIcon className="checkbox-btn__label-uncheck" />
            </span>
          ) : ''}
        <span className="checkbox-btn__label">
          {label}
        </span>
      </label>
    );
  }
}

const renderCheckBoxField = (props) => {
  const {
    input,
    label,
    defaultChecked,
    disabled,
    className,
    color,
    style,
    labelStyle,
    meta: {
      touched, error,
    },
  } = props;

  return (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error">
      <CheckBoxField
        {...input}
        label={label}
        defaultChecked={defaultChecked}
        disabled={disabled}
        className={className}
        style={style}
        labelStyle={labelStyle}
        color={color}
      />
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );
};

renderCheckBoxField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
  label: PropTypes.node, // Cambiado de string a node
  defaultChecked: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  disabled: PropTypes.bool,
  style: PropTypes.shape({}),
  labelStyle: PropTypes.shape({}),
  className: PropTypes.string,
  color: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.any,
  }),
};

renderCheckBoxField.defaultProps = {
  label: '',
  defaultChecked: false,
  value: false,
  disabled: false,
  style: {},
  labelStyle: {},
  className: '',
  color: '',
  meta: {},
};

export default renderCheckBoxField;
